// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1sNtW","topBottomGutter":"Layout_topBottomGutter__2Q2_T"};